<template>
</template>
<script>
export default {
	mounted() {
		var self = this;
		self.$router.push({
			name: 'Login', 
			params: {
				method: 'fakeUserLogin',
			},
		});
	},
};	
</script>